import { render, staticRenderFns } from "./TasteRating.vue?vue&type=template&id=0982aff0"
import script from "./TasteRating.vue?vue&type=script&lang=js"
export * from "./TasteRating.vue?vue&type=script&lang=js"
import style0 from "./TasteRating.vue?vue&type=style&index=0&id=0982aff0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports